function countDecimals(value: string): number {
  const dot = value.indexOf('.')
  if (dot === -1) return 0
  return value.slice(dot + 1).replace(/0+$/, '').length
}

/**
 * Adds numeric strings and gets the answer a person would get on paper.
 *
 * Adding 399.60 three times and 284.40 with plain `+` gives 1483.2000000000003,
 * because those values have no exact binary form. Scaling every value up to a
 * whole number first, adding those, then scaling the total back down avoids it.
 *
 * Values that aren't numbers are skipped.
 */
export function sumDecimalStrings(
  values: (string | null | undefined)[],
): string {
  const numbers: number[] = []
  let decimals = 0

  values.forEach((value) => {
    if (!value) return
    const parsed = parseFloat(value)
    if (isNaN(parsed)) return

    numbers.push(parsed)
    decimals = Math.max(decimals, countDecimals(value))
  })

  const scale = 10 ** decimals
  const total = numbers.reduce((acc, n) => acc + Math.round(n * scale), 0)
  return (total / scale).toString()
}

export function getMaxDecimals(values: (string | null | undefined)[]): number {
  let max = 0
  values.forEach((value) => {
    if (!value) return
    max = Math.max(max, countDecimals(value))
  })
  return max
}
